import ReconciliationStatus from '@/components/_modules/Programs/Card-transactions/ReconciliationStatus.vue'
import TransactionStatus from '@/components/_modules/Programs/Card-transactions/TransactionStatus.vue'
import OpenReconcile from './OpenReconcile'
import OpenEnvelope from '@/components/_modules/Programs/Card-envelopes/OpenEnvelope.vue'
import { gotoCustom } from '@/components/Grid/cells/actions'

export default {
  'TransactionNumber': {
    label: 'Transaction',
    render: OpenReconcile,
    width: 120
  },

  'FusionVersionNumber': {
    label: 'Expense',
    width: 120,
    visible: false
  },

  'CardNumber': {
    label: 'Card',
    compose: maskedCardNumber,
    width: 100
  },

  'Division': {
    label: 'Division',
    getter: getDivisionLink,
    width: 180
  },

  'Holder': {
    label: 'Card Holder',
    width: 120
  },

  'Merchant': {
    label: 'Merchant',
    visible: false,
    width: 120
  },

  'SupplierNameCombined': {
    label: 'Supplier',
    compose: supplierName,
    width: 120
  },

  'TransactionDateFormatted': {
    label: 'Date',
    width: 90
  },

  'Amount': {
    label: 'Amount',
    width: 120,
    infoMessageIcon: 'fas fa-info-circle grey-icon',
    infoMessage: params => {
      return params.data.IsFeeOnAccount ? 'Rush orders do not count against the card balance' : null
    },
    f: 'data.Amount'
  },

  'TransactionStatus': {
    label: 'Transaction Status',
    source: 'TransactionsList',
    render: TransactionStatus,
    width: 120
  },

  'ReconciliationStatus': {
    label: 'Reconciliation Status',
    source: 'TransactionsList',
    render: ReconciliationStatus,
    width: 140
  },

  'EnvelopeNumber': {
    label: 'Envelope',
    render: OpenEnvelope,
    width: 120
  },

  'APFile': {
    label: 'AP File',
    compose: apFileLink,
    width: 120
  },

  'ProgramName': {
    label: 'Program',
    width: 120
  },

  AccountId: '_'
}

function maskedCardNumber(card) {
  if (card && card.data && card.data.CardNumber) {
    return '****' + card.data.CardNumber
  } else {
    return '****'
  }
}

function supplierName(column) {
  if (column && column.data) {
    if (!(column.data.Supplier || column.data.NonEvedSupplier)) {
      return `<span title="${column.data.Merchant}" style="color: #989898;">${column.data.Merchant}</span>`
    }
    return column.data.SupplierNameCombined
  }
  return ''
}

function getDivisionLink(params) {
  if (params && params.data && params.data.AccountId) {
    params.node.uri = params.colDef.uri = `#/d/Programs/>Card/list?AccountId=${params.data.AccountId}`
    params.value = params.data.Division
    params.noTooltip = true

    return gotoCustom.template(params)
  } else {
    return ''
  }
}

function apFileLink(p) {
  if (!p.data) return ''

  const apFileId = p.data.ApFileId

  const url = `${global.app.api.env}/AccountPayable/GenerateEvedPayCardAPFile?apFileId=${apFileId}`

  return `<a title="Open AP File" href="${url}" target="_blank">${p.value}</a>`
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-transactions/model.js